import { SearchVehicle } from "@/graphql/queries.js";
import { API, graphqlOperation } from "aws-amplify";
import { GetAllChats } from "@/mixins/Chat/ListChats.js";
import { SetLocationMy } from "@/mixins/Methods/SetLocation.js";

export const GetVehicleDetails = {
  mixins: [GetAllChats, SetLocationMy],
  data() {
    return {
      carDetailsObject: {},
      userDetailsObject: {},
      GetVehicleDetailsObject: {},
      overlay: false,
      user_type: "",
    };
  },
  methods: {
    async GetVehicleDetailsMethod(license_plate_number) {
      try {
        this.overlay = true;

        // this.$store.commit("SET_CAR_DETAILS", {});
        this.hasaccessRoutesList = [];
        let result = await API.graphql(
          graphqlOperation(SearchVehicle, {
            input: {
              license_plate_number,
              user_id: this.$store.getters.get_current_user_details.user_id,
            },
          })
        );
        this.GetVehicleDetailsObject = JSON.parse(
          result.data.SearchVehicle
        ).data.items;

        console.log(
          "this.GetVehicleDetailsObject",
          this.GetVehicleDetailsObject
        );

        this.userDetailsObject = JSON.parse(
          result.data.SearchVehicle
        ).data.items.user_Details[0];

        this.$store.commit("SET_MOTORIST_NAME", this.userDetailsObject);
        this.carDetailsObject = JSON.parse(
          result.data.SearchVehicle
        ).data.items.car_details[0];
        this.$store.commit("SET_CAR_DETAILS", this.carDetailsObject);
        this.$store.commit("SET_MOTORIST_AGAIN", false);

        this.GetAllChatsMethod();

        // this.latitude = this.userDetailsObject.user_latitude;
        // this.longitude = this.userDetailsObject.user_longitude;

        this.convertCoordinatesToAddress();
        this.SetMyLocationMethod();

        await this.GetImage();
        await this.generateImageUrls();

        this.AllCarDetails = false;
        this.overlay = false;
        this.$store.commit("SET_MOTORIST_BOOLEAN", true);
        return "DRIVER_FOUND";
      } catch (error) {
        this.overlay = false;
        if (
          error.errors[0].message ==
          "Driver has hidden the profile! Request access."
        ) {
          this.overlay = false;
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            Top: true,
            SnackbarText: error.errors[0].message,
          };
          return "DRIVER_HIDDEN";
        } else if (error.errors[0].message == "Driver Details Not Found!!!") {
          this.overlay = false;
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            Top: true,
            SnackbarText: error.errors[0].message,
          };
        } else {
          this.overlay = false;
          return "Error";
        }
      }
    },
  },
};
